import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '~/routes/use-on-load';
import { P2GBox } from '@parcel2go/core-ui';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

// Account-experience Communications page (standalone sidebar item). Mounts the existing
// communication-preferences component (Order Notifications + Marketing) as-is.
const CommunicationPreferences = lazy(() => import('~/apps/communication-preferences/communication-preferences'));

export default function Component() {
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.COMMUNICATION_PREFERENCES);

  useOnLoad(() => {
    const title = t('COMMUNICATIONS_PAGE_TITLE', { defaultValue: 'Communications' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.COMMUNICATION_PREFERENCES });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Communications }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Communications
      }
    });
  });

  return (
    <Tagged tag="screen-communications">
      <Suspense>
        <P2GBox>
          <CommunicationPreferences />
        </P2GBox>
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'Communications';
